export function insertTokenAtPosition(
  text: string,
  position: number,
  refId: string,
): string {
  const safe = Math.max(0, Math.min(position, text.length));
  return text.slice(0, safe) + `{{ref:${refId}}}` + text.slice(safe);
}

export function replaceTokenInText(
  text: string,
  oldRefId: string,
  newRefId: string,
): string {
  return text.split(`{{ref:${oldRefId}}}`).join(`{{ref:${newRefId}}}`);
}

export function removeTokenFromText(
  text: string,
  refId: string,
  replacementText: string,
): string {
  return text.split(`{{ref:${refId}}}`).join(replacementText);
}

export function tokenNeedle(refId: string): string {
  return `{{ref:${refId}}}`;
}

export function findTokenPositionAtOccurrence(
  text: string,
  refId: string,
  occurrenceIndex: number,
): number | null {
  const needle = tokenNeedle(refId);
  let from = 0;
  for (let i = 0; i <= occurrenceIndex; i++) {
    const pos = text.indexOf(needle, from);
    if (pos < 0) return null;
    if (i === occurrenceIndex) return pos;
    from = pos + needle.length;
  }
  return null;
}

export function replaceTokenAtPosition(
  text: string,
  tokenId: string,
  position: number,
  newTokenId: string,
): string | null {
  const needle = tokenNeedle(tokenId);
  if (text.slice(position, position + needle.length) !== needle) {
    return null;
  }
  return (
    text.slice(0, position) +
    tokenNeedle(newTokenId) +
    text.slice(position + needle.length)
  );
}

export function removeTokenAtPosition(
  text: string,
  tokenId: string,
  position: number,
  replacementText: string,
): string | null {
  const needle = tokenNeedle(tokenId);
  if (text.slice(position, position + needle.length) !== needle) {
    return null;
  }
  return (
    text.slice(0, position) + replacementText + text.slice(position + needle.length)
  );
}

// Splice a {{ref:UUID}} token in place of the [position, position+length)
// slice of `text`. When `length === 0`, behaves like
// insertTokenAtPosition. A negative `length` is treated as `0` (behaves
// like a caret insert). When `position` is negative, it clamps to `0` and
// `length` is applied from that clamped start (not the original negative
// position).
//
// The splice is purely character-based — if the removed slice contains a
// nested {{ref:UUID}} token, its DB Reference row is orphaned. Caller is
// responsible for any reconciliation.
export function replaceRangeWithToken(
  text: string,
  position: number,
  length: number,
  refId: string,
): string {
  const safeStart = Math.max(0, Math.min(position, text.length));
  const safeEnd = Math.min(safeStart + Math.max(0, length), text.length);
  return text.slice(0, safeStart) + `{{ref:${refId}}}` + text.slice(safeEnd);
}
